/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { Form, Input, Col, Row, Spin, Button } from "antd";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  clearPostShipment,
  getBarcodeId,
  postShipment,
} from "../../actionsMethods/cashBookingMethods";
import ChildModal from "./ChildModal";
import "./style.scss";

const BookingDetails = ({ screen, currentScreen }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const formLayout = "vertical";
  const [ModalVisible, setModalVisible] = useState(false);
  const [details, setDetails] = useState();
  const [childData, setChildData] = useState();
  const userId = JSON.parse(localStorage.getItem("userId"));
  const [childPacketSubmitted, setChildPacketSubmitted] = useState(false);
  let serviceType = "1";

  const getBookingIdResponse = useSelector(
    (state) => state.appReducer.getBarcodeIdReducer,
    shallowEqual
  );

  const postShipmentResponse = useSelector(
    (state) => state?.appReducer?.getPostShipmentReducer,
    shallowEqual
  );

  const { fetching, result, error } = getBookingIdResponse;
  const {
    result: postShipmentResult,
    error: postError,
    fetching: postFetching,
  } = postShipmentResponse;

  useEffect(() => {
    form.setFieldsValue({
      awbNumber: result?.data?.awbNumber,
    });
  }, [result]);

  useEffect(() => {
    setDetails(JSON.parse(localStorage.getItem("details")));
    setChildData(JSON.parse(localStorage.getItem("childPackets")));
  }, [screen]);

  useEffect(() => {
    if (currentScreen === 1 && getBookingIdResponse?.result === null) {
      if (details?.selectedMode?.mode === "Fast Track") {
        serviceType = "2";
        dispatch(
          getBarcodeId(serviceType, userId?.userInfo?.premiseId, "CASH")
        );
      }
      if (details?.selectedMode?.mode === "Value Plus") {
        serviceType = "3";
        dispatch(
          getBarcodeId(serviceType, userId?.userInfo?.premiseId, "CASH")
        );
      }
      if (details?.selectedMode?.mode === "Standard") {
        serviceType = "1";
        dispatch(
          getBarcodeId(serviceType, userId?.userInfo?.premiseId, "CASH")
        );
      }
    }
  }, [
    details?.selectedMode?.mode,
    serviceType,
    currentScreen,
    getBookingIdResponse?.result,
  ]);

  useEffect(() => {
    if (result?.data?.awbNumber && currentScreen === 1) {
      let data = {
        awbNumber: result?.data?.awbNumber,
        premiseId: userId?.userInfo?.premiseId,
        bookingType: "Cash",
        userId: userId?.userInfo?.userId,
        destinationPincode: details?.deliveryPincode,
      };
      if (postShipmentResult === null) {
        dispatch(postShipment(data, userId?.userInfo?.premiseId));
      }
    }
  }, [result?.data?.awbNumber, postShipmentResult]);

  useEffect(() => {
    form.setFieldsValue({
      deliveryPincode: details?.deliveryPincode,
      area: details?.area,
      pickupPincode: userId?.premises?.pincode,
    });
  }, [currentScreen, details]);

  const onSubmitFormData = (values) => {
    let awbNumber = values?.awbNumber;
    let newDetails = { ...details, awbNumber };
    localStorage.setItem("details", JSON.stringify(newDetails));
    screen(2);
  };

  const formProps = {
    name: "address",
    className: "register-form",
    onFinish: onSubmitFormData,
    autoComplete: "off",
  };

  const handleOpenCal = () => {
    return screen(0);
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  const handleSubmitModal = () => {
    setModalVisible(false);
    setChildPacketSubmitted(true);
  };

  const handleChildModal = () => {
    setModalVisible(true);
  };

  return (
    <>
      {details && details?.deliveryPincode && (
        <Spin spinning={fetching || postFetching}>
          {details?.child_Selected && result?.data?.awbNumber ? (
            <ChildModal
              visible={ModalVisible}
              handleCancel={handleCancel}
              childData={childData}
              awb={result?.data?.awbNumber}
              serviceType={serviceType}
              handleSubmitModal={handleSubmitModal}
              currentScreen={currentScreen}
              premiseId={userId?.userInfo?.premiseId}
              childDetails={details?.fields}
              deliveryPincode={details?.deliveryPincode}
            />
          ) : null}

          <Form {...formProps} layout={formLayout} form={form}>
            <Row
              className="booking-details-container mainForm"
              justify="space-evenly"
              gutter={64}
            >
              <Col
                className="form-inputs"
                lg={11}
                xs={11}
                md={11}
                xl={11}
                offset={1}
              >
                <Form.Item name="pickupPincode" label="Pickup PIN code">
                  <Input disabled suffix={userId?.premises?.stateCode} />
                </Form.Item>
                <Form.Item
                  name="awbNumber"
                  label="AWB No"
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                  ]}
                >
                  <Input placeholder="Enter booking no" disabled />
                </Form.Item>
                <p style={{ color: "red", textAlign: "start" }}>
                  {error?.message}
                </p>
                <p style={{ textAlign: "start" }}>
                  {details?.child_Selected && result?.data?.awbNumber && (
                    <div>
                      <span
                        onClick={handleChildModal}
                        className="pointer"
                        style={{ color: " #1890ff" }}
                      >
                        Click here
                      </span>
                      <span> {"to enter child packets number"}</span>
                    </div>
                  )}
                </p>

                <p
                  style={{
                    textAlign: "initial",
                    marginTop: "-13px",
                    color: "red",
                  }}
                >
                  {postError?.message}
                </p>
              </Col>

              <Col
                className="form-inputs"
                lg={11}
                xs={11}
                md={11}
                xl={11}
                offset={1}
              >
                <Form.Item name="deliveryPincode" label="Delivery PIN Code">
                  <Input
                    disabled
                    className={
                      details?.seriviceResult?.serviceability ==
                      "serviceable_regular"
                        ? "green"
                        : details?.seriviceResult?.serviceability ==
                          "serviceable_premium"
                        ? "orange"
                        : "red"
                    }
                    suffix={details?.seriviceResult?.serviceability?.stateCode}
                  />
                </Form.Item>
                <Form.Item name="area" label="Area" className="bookingAreaItem">
                  <Input disabled />
                </Form.Item>
              </Col>
            </Row>
            <Row className="button-container">
              <Col span={24}>
                <div className="steps-action">
                  {currentScreen === 2 ? (
                    <Button
                      onClick={() => handleOpenCal()}
                      className="back-button"
                    >
                      {"BACK"}
                    </Button>
                  ) : (
                    ""
                  )}

                  <Button
                    htmlType="submit"
                    type="primary"
                    className="next-button"
                    disabled={
                      details?.child_Selected && childPacketSubmitted === false
                    }
                  >
                    {"NEXT"}
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Spin>
      )}
    </>
  );
};

export default React.memo(BookingDetails);
